export default {"src":"/_next/static/media/UNIT.bab262ed.svg","height":18,"width":18};